export const translations = {
    'en-US': {
        nav: {
            home: 'Home',
            features: 'Features',
            howItWorks: 'How It Works',
            nfcCards: 'NFC Cards',
            reviews: 'Reviews',
            appCards: 'App Cards',
            personalCard: 'Personal Card',
            businessCard: 'Business Card',
            enterprise: 'Enterprise',
            soon: 'Soon',
            cards: 'Cards',
            nfc: 'NFC',
            appNfcCards: 'App NFC Cards',
            customCards: 'Custom Cards',
            blog: 'Blog',
            about: 'About',
            contact: 'Contact',
            cart: 'Cart',
            login: 'Login',
            signUp: 'Sign Up',
            sign: 'Sign',
            myAccount: 'My Account',
            logout: 'Logout'
        },
        common: {
            color: 'Color',
            colors: 'Colors',
            colored: 'Colored',
            coloring: 'Coloring',
            colorful: 'Colorful',
            colorless: 'Colorless',
            customize: 'Customize',
            customizes: 'Customizes',
            customized: 'Customized',
            customizing: 'Customizing',
            customizable: 'Customizable',
            customization: 'Customization',
            analyze: 'Analyze',
            analyzes: 'Analyzes',
            analyzed: 'Analyzed',
            analyzing: 'Analyzing',
            analyzable: 'Analyzable',
            analysis: 'Analysis',
            analyzer: 'Analyzer',
            organize: 'Organize',
            organizes: 'Organizes',
            organized: 'Organized',
            organizing: 'Organizing',
            organizable: 'Organizable',
            organization: 'Organization',
            organizational: 'Organizational',
            organizer: 'Organizer',
            optimize: 'Optimize',
            optimizes: 'Optimizes',
            optimized: 'Optimized',
            optimizing: 'Optimizing',
            optimization: 'Optimization',
            optimizer: 'Optimizer',
            personalize: 'Personalize',
            personalizes: 'Personalizes',
            personalized: 'Personalized',
            personalizing: 'Personalizing',
            personalizable: 'Personalizable',
            personalization: 'Personalization',
            modernize: 'Modernize',
            modernizes: 'Modernizes',
            modernized: 'Modernized',
            modernizing: 'Modernizing',
            modernization: 'Modernization',
            digitize: 'Digitize',
            digitizes: 'Digitizes',
            digitized: 'Digitized',
            digitizing: 'Digitizing',
            digitization: 'Digitization',
            maximize: 'Maximize',
            maximizes: 'Maximizes',
            maximized: 'Maximized',
            maximizing: 'Maximizing',
            maximization: 'Maximization',
            minimize: 'Minimize',
            minimizes: 'Minimizes',
            minimized: 'Minimized',
            minimizing: 'Minimizing',
            minimization: 'Minimization',
            realize: 'Realize',
            realizes: 'Realizes',
            realized: 'Realized',
            realizing: 'Realizing',
            realizable: 'Realizable',
            realization: 'Realization',
            specialize: 'Specialize',
            specializes: 'Specializes',
            specialized: 'Specialized',
            specializing: 'Specializing',
            specialization: 'Specialization',
            synchronize: 'Synchronize',
            synchronizes: 'Synchronizes',
            synchronized: 'Synchronized',
            synchronizing: 'Synchronizing',
            synchronization: 'Synchronization',
            standardize: 'Standardize',
            standardizes: 'Standardizes',
            standardized: 'Standardized',
            standardizing: 'Standardizing',
            standardization: 'Standardization',
            authorize: 'Authorize',
            authorizes: 'Authorizes',
            authorized: 'Authorized',
            authorizing: 'Authorizing',
            authorization: 'Authorization',
            prioritize: 'Prioritize',
            prioritizes: 'Prioritizes',
            prioritized: 'Prioritized',
            prioritizing: 'Prioritizing',
            prioritization: 'Prioritization',
            visualize: 'Visualize',
            visualizes: 'Visualizes',
            visualized: 'Visualized',
            visualizing: 'Visualizing',
            visualization: 'Visualization',
            capitalize: 'Capitalize',
            capitalizes: 'Capitalizes',
            capitalized: 'Capitalized',
            capitalizing: 'Capitalizing',
            capitalization: 'Capitalization',
            categorize: 'Categorize',
            categorizes: 'Categorizes',
            categorized: 'Categorized',
            categorizing: 'Categorizing',
            categorization: 'Categorization',
            center: 'Center',
            centers: 'Centers',
            centered: 'Centered',
            centering: 'Centering',
            central: 'Central',
            centralize: 'Centralize',
            centralized: 'Centralized',
            fiber: 'Fiber',
            fibers: 'Fibers',
            fibered: 'Fibered',
            meter: 'Meter',
            meters: 'Meters',
            metered: 'Metered',
            metering: 'Metering',
            liter: 'Liter',
            liters: 'Liters',
            theater: 'Theater',
            theaters: 'Theaters',
            aluminum: 'Aluminum',
            program: 'Program',
            programs: 'Programs',
            programmed: 'Programmed',
            programming: 'Programming',
            programmable: 'Programmable',
            programmer: 'Programmer',
            dialog: 'Dialog',
            dialogs: 'Dialogs',
            catalog: 'Catalog',
            catalogs: 'Catalogs',
            cataloged: 'Cataloged',
            cataloging: 'Cataloging',
            analog: 'Analog',
            canceled: 'Canceled',
            canceling: 'Canceling',
            cancelation: 'Cancelation',
            traveled: 'Traveled',
            traveling: 'Traveling',
            traveler: 'Traveler',
            labeled: 'Labeled',
            labeling: 'Labeling',
            modeled: 'Modeled',
            modeling: 'Modeling',
            leveled: 'Leveled',
            leveling: 'Leveling',
            signaled: 'Signaled',
            signaling: 'Signaling',
            totaled: 'Totaled',
            totaling: 'Totaling',
            channeled: 'Channeled',
            channeling: 'Channeling',
            fueled: 'Fueled',
            fueling: 'Fueling',
            jewelry: 'Jewelry',
            acknowledgment: 'Acknowledgment',
            acknowledgments: 'Acknowledgments',
            judgment: 'Judgment',
            judgments: 'Judgments',
            license: 'License',
            licenses: 'Licenses',
            licensed: 'Licensed',
            licensing: 'Licensing',
            defense: 'Defense',
            defenses: 'Defenses',
            defensive: 'Defensive',
            offense: 'Offense',
            offenses: 'Offenses',
            offensive: 'Offensive',
            practice: 'Practice',
            practices: 'Practices',
            practiced: 'Practiced',
            practicing: 'Practicing',
            check: 'Check',
            checks: 'Checks',
            checked: 'Checked',
            checking: 'Checking',
            gray: 'Gray',
            grays: 'Grays',
            grayed: 'Grayed',
            graying: 'Graying',
            grayish: 'Grayish',
            toward: 'Toward',
            among: 'Among',
            while: 'While',
            gotten: 'Gotten',
            airplane: 'Airplane',
            airplanes: 'Airplanes',
            elevator: 'Elevator',
            elevators: 'Elevators',
            cookie: 'Cookie',
            cookies: 'Cookies',
            fall: 'Fall',
            gasoline: 'Gasoline',
            highway: 'Highway',
            highways: 'Highways',
            mail: 'Mail',
            mailed: 'Mailed',
            mailing: 'Mailing',
            movie: 'Movie',
            movies: 'Movies',
            parking_lot: 'Parking lot',
            parking_lots: 'Parking lots',
            railroad: 'Railroad',
            railroads: 'Railroads',
            sidewalk: 'Sidewalk',
            sidewalks: 'Sidewalks',
            store: 'Store',
            stores: 'Stores',
            stored: 'Stored',
            storing: 'Storing',
            subway: 'Subway',
            subways: 'Subways',
            trash: 'Trash',
            truck: 'Truck',
            trucks: 'Trucks',
            vacation: 'Vacation',
            vacations: 'Vacations',
            vacationed: 'Vacationed',
            vacationing: 'Vacationing',
            zipper: 'Zipper',
            zippers: 'Zippers',
            apartment: 'Apartment',
            apartments: 'Apartments',
            bathroom: 'Bathroom',
            bathrooms: 'Bathrooms',
            closet: 'Closet',
            closets: 'Closets',
            diaper: 'Diaper',
            diapers: 'Diapers',
            faucet: 'Faucet',
            faucets: 'Faucets',
            flashlight: 'Flashlight',
            flashlights: 'Flashlights',
            garbage: 'Garbage',
            period: 'Period',
            periods: 'Periods',
            eraser: 'Eraser',
            erasers: 'Erasers',
            math: 'Math',
            principal: 'Principal',
            principals: 'Principals',
            recess: 'Recess',
            recesses: 'Recesses',
            schedule: 'Schedule',
            schedules: 'Schedules',
            scheduled: 'Scheduled',
            scheduling: 'Scheduling'
        }
    },
    'en-GB': {
        nav: {
            home: 'Home',
            features: 'Features',
            howItWorks: 'How It Works',
            nfcCards: 'NFC Cards',
            reviews: 'Reviews',
            appCards: 'App Cards',
            personalCard: 'Personal Card',
            businessCard: 'Business Card',
            enterprise: 'Enterprise',
            soon: 'Soon',
            cards: 'Cards',
            nfc: 'NFC',
            appNfcCards: 'App NFC Cards',
            customCards: 'Custom Cards',
            blog: 'Blog',
            about: 'About',
            contact: 'Contact',
            cart: 'Cart',
            login: 'Login',
            signUp: 'Sign Up',
            sign: 'Sign',
            myAccount: 'My Account',
            logout: 'Logout'
        },
        common: {
            color: 'Colour',
            colors: 'Colours',
            colored: 'Coloured',
            coloring: 'Colouring',
            colorful: 'Colourful',
            colorless: 'Colourless',
            customize: 'Customise',
            customizes: 'Customises',
            customized: 'Customised',
            customizing: 'Customising',
            customizable: 'Customisable',
            customization: 'Customisation',
            analyze: 'Analyse',
            analyzes: 'Analyses',
            analyzed: 'Analysed',
            analyzing: 'Analysing',
            analyzable: 'Analysable',
            analysis: 'Analysis',
            analyzer: 'Analyser',
            organize: 'Organise',
            organizes: 'Organises',
            organized: 'Organised',
            organizing: 'Organising',
            organizable: 'Organisable',
            organization: 'Organisation',
            organizational: 'Organisational',
            organizer: 'Organiser',
            optimize: 'Optimise',
            optimizes: 'Optimises',
            optimized: 'Optimised',
            optimizing: 'Optimising',
            optimization: 'Optimisation',
            optimizer: 'Optimiser',
            personalize: 'Personalise',
            personalizes: 'Personalises',
            personalized: 'Personalised',
            personalizing: 'Personalising',
            personalizable: 'Personalisable',
            personalization: 'Personalisation',
            modernize: 'Modernise',
            modernizes: 'Modernises',
            modernized: 'Modernised',
            modernizing: 'Modernising',
            modernization: 'Modernisation',
            digitize: 'Digitise',
            digitizes: 'Digitises',
            digitized: 'Digitised',
            digitizing: 'Digitising',
            digitization: 'Digitisation',
            maximize: 'Maximise',
            maximizes: 'Maximises',
            maximized: 'Maximised',
            maximizing: 'Maximising',
            maximization: 'Maximisation',
            minimize: 'Minimise',
            minimizes: 'Minimises',
            minimized: 'Minimised',
            minimizing: 'Minimising',
            minimization: 'Minimisation',
            realize: 'Realise',
            realizes: 'Realises',
            realized: 'Realised',
            realizing: 'Realising',
            realizable: 'Realisable',
            realization: 'Realisation',
            specialize: 'Specialise',
            specializes: 'Specialises',
            specialized: 'Specialised',
            specializing: 'Specialising',
            specialization: 'Specialisation',
            synchronize: 'Synchronise',
            synchronizes: 'Synchronises',
            synchronized: 'Synchronised',
            synchronizing: 'Synchronising',
            synchronization: 'Synchronisation',
            standardize: 'Standardise',
            standardizes: 'Standardises',
            standardized: 'Standardised',
            standardizing: 'Standardising',
            standardization: 'Standardisation',
            authorize: 'Authorise',
            authorizes: 'Authorises',
            authorized: 'Authorised',
            authorizing: 'Authorising',
            authorization: 'Authorisation',
            prioritize: 'Prioritise',
            prioritizes: 'Prioritises',
            prioritized: 'Prioritised',
            prioritizing: 'Prioritising',
            prioritization: 'Prioritisation',
            visualize: 'Visualise',
            visualizes: 'Visualises',
            visualized: 'Visualised',
            visualizing: 'Visualising',
            visualization: 'Visualisation',
            capitalize: 'Capitalise',
            capitalizes: 'Capitalises',
            capitalized: 'Capitalised',
            capitalizing: 'Capitalising',
            capitalization: 'Capitalisation',
            categorize: 'Categorise',
            categorizes: 'Categorises',
            categorized: 'Categorised',
            categorizing: 'Categorising',
            categorization: 'Categorisation',
            center: 'Centre',
            centers: 'Centres',
            centered: 'Centred',
            centering: 'Centring',
            central: 'Central',
            centralize: 'Centralise',
            centralized: 'Centralised',
            fiber: 'Fibre',
            fibers: 'Fibres',
            fibered: 'Fibred',
            meter: 'Metre',
            meters: 'Metres',
            metered: 'Metred',
            metering: 'Metring',
            liter: 'Litre',
            liters: 'Litres',
            theater: 'Theatre',
            theaters: 'Theatres',
            aluminum: 'Aluminium',
            program: 'Programme',
            programs: 'Programmes',
            programmed: 'Programmed',
            programming: 'Programming',
            programmable: 'Programmable',
            programmer: 'Programmer',
            dialog: 'Dialogue',
            dialogs: 'Dialogues',
            catalog: 'Catalogue',
            catalogs: 'Catalogues',
            cataloged: 'Catalogued',
            cataloging: 'Cataloguing',
            analog: 'Analogue',
            canceled: 'Cancelled',
            canceling: 'Cancelling',
            cancelation: 'Cancellation',
            traveled: 'Travelled',
            traveling: 'Travelling',
            traveler: 'Traveller',
            labeled: 'Labelled',
            labeling: 'Labelling',
            modeled: 'Modelled',
            modeling: 'Modelling',
            leveled: 'Levelled',
            leveling: 'Levelling',
            signaled: 'Signalled',
            signaling: 'Signalling',
            totaled: 'Totalled',
            totaling: 'Totalling',
            channeled: 'Channelled',
            channeling: 'Channelling',
            fueled: 'Fuelled',
            fueling: 'Fuelling',
            jewelry: 'Jewellery',
            acknowledgment: 'Acknowledgement',
            acknowledgments: 'Acknowledgements',
            judgment: 'Judgement',
            judgments: 'Judgements',
            license: 'Licence',
            licenses: 'Licences',
            licensed: 'Licensed',
            licensing: 'Licensing',
            defense: 'Defence',
            defenses: 'Defences',
            defensive: 'Defensive',
            offense: 'Offence',
            offenses: 'Offences',
            offensive: 'Offensive',
            practice: 'Practise',
            practices: 'Practises',
            practiced: 'Practised',
            practicing: 'Practising',
            check: 'Check',
            checks: 'Checks',
            checked: 'Checked',
            checking: 'Checking',
            gray: 'Grey',
            grays: 'Greys',
            grayed: 'Greyed',
            graying: 'Greying',
            grayish: 'Greyish',
            toward: 'Towards',
            among: 'Amongst',
            while: 'Whilst',
            gotten: 'Got',
            airplane: 'Aeroplane',
            airplanes: 'Aeroplanes',
            elevator: 'Lift',
            elevators: 'Lifts',
            cookie: 'Cookies',
            cookies: 'Cookies',
            fall: 'Autumn',
            gasoline: 'Petrol',
            highway: 'Motorway',
            highways: 'Motorways',
            mail: 'Post',
            mailed: 'Posted',
            mailing: 'Posting',
            movie: 'Film',
            movies: 'Films',
            parking_lot: 'Car park',
            parking_lots: 'Car parks',
            railroad: 'Railway',
            railroads: 'Railways',
            sidewalk: 'Pavement',
            sidewalks: 'Pavements',
            store: 'Store',
            stores: 'Shops',
            stored: 'Stored',
            storing: 'Storing',
            subway: 'Underground',
            subways: 'Undergrounds',
            trash: 'Rubbish',
            truck: 'Lorry',
            trucks: 'Lorries',
            vacation: 'Holiday',
            vacations: 'Holidays',
            vacationed: 'Holidayed',
            vacationing: 'Holidaying',
            zipper: 'Zip',
            zippers: 'Zips',
            apartment: 'Flat',
            apartments: 'Flats',
            bathroom: 'Loo',
            bathrooms: 'Loos',
            closet: 'Wardrobe',
            closets: 'Wardrobes',
            diaper: 'Nappy',
            diapers: 'Nappies',
            faucet: 'Tap',
            faucets: 'Taps',
            flashlight: 'Torch',
            flashlights: 'Torches',
            garbage: 'Rubbish',
            period: 'Full stop',
            periods: 'Full stops',
            eraser: 'Rubber',
            erasers: 'Rubbers',
            math: 'Maths',
            principal: 'Head teacher',
            principals: 'Head teachers',
            recess: 'Break',
            recesses: 'Breaks',
            schedule: 'Timetable',
            schedules: 'Timetables',
            scheduled: 'Timetabled',
            scheduling: 'Timetabling'
        }
    }
};

export const translateText = (text, language = 'en-US') => {
    if (!text) return '';

    const dict = translations[language] || translations['en-US'];

    let translatedText = text;

    Object.entries(dict.common).forEach(([usWord, gbWord]) => {
        if (language === 'en-GB') {
            const regex = new RegExp(`\\b${usWord}\\b`, 'gi');
            translatedText = translatedText.replace(regex, (match) => {
                return match[0] === match[0].toUpperCase() ?
                    gbWord.charAt(0).toUpperCase() + gbWord.slice(1) : gbWord;
            });
        }
    });

    return translatedText;
};

export const t = (key, language = 'en-US') => {
    const keys = key.split('.');
    let value = translations[language] || translations['en-US'];

    for (const k of keys) {
        value = value?.[k];
    }

    return value || key;
};